import * as React from "react";
import { connect } from "react-redux";
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { MenuWrapper } from "../menus/MenuWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
export var _MenuLibrary = function (_a) {
    var onClose = _a.onClose;
    return (React.createElement(MenuWrapper, { onClose: onClose, className: "library-menu", type: IdMenuBalancing.Library, modalId: IdModal.Library }));
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.Library)); },
}); };
export var MenuLibrary = connect(undefined, mapDispatch)(_MenuLibrary);



//////////////////
// WEBPACK FOOTER
// ./src/features/library/MenuLibrary.tsx
// module id = 2844
// module chunks = 3